<template lang="pug">
  div
    divider(label="Dados do Processo")
    div.mt-1.padding-info-analise
      el-row.labelDiv
        el-col.inputDiv(:span="12" :lg="8")
          div.col
            span.label Responsável:
            span {{ responsavel }}
        el-col(:span="12" :lg="8")
          div.col
            span.label Cargo:
            span {{ cargo }}
        el-col(:span="12" :lg="4")
          div.col
            span.label Data:
            span {{ dataFormatada }}
        el-col(:span="12" :lg="4")
          div.col
            span.label Hora:
            span {{ hora }}

</template>

<script>
import Divider from '@/screens/arrecadacao/components/Divider'
import Utils from '@/utils/utils'

export default {
  components: {
    Divider
  },

  props: {
    responsavel: {
      required: true,
      type: String
    },

    cargo: {
      required: true,
      type: String
    },

    data: {
      required: true
    }
  },

  computed: {
    dataFormatada () {
      if (!this.data) return ''

      return Utils.formatDate(this.data)
    },

    hora () {
      if (!this.data) return ''

      return Utils.formatDate(this.data, 'HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  font-weight: 600;
  margin-right: 10px;
}

span {
  font-size: 15px;
}

.padding-info-analise {
  padding: 0 1rem 0 1rem;
}

.col {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/components/InformacoesAnalise.vue